(() => {
  const init = () => {
    document.querySelectorAll('[data-onyra-gallery]').forEach(gallery => {
      const scroller = gallery.querySelector('[data-onyra-gallery-grid]');
      const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
      if (!scroller || scroller.dataset.dotsReady) return;
      scroller.dataset.dotsReady = 'true';
      let pointerStart = null;
      let dragged = false;
      scroller.addEventListener('pointerdown', event => {
        pointerStart = { x: event.clientX, y: event.clientY };
        dragged = false;
      }, { passive: true });
      scroller.addEventListener('pointermove', event => {
        if (pointerStart && Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y) > 8) dragged = true;
      }, { passive: true });
      scroller.addEventListener('pointercancel', () => { pointerStart = null; dragged = true; });
      scroller.querySelectorAll('.product-main-slide').forEach(slide => {
        const image = slide.querySelector('.photoswipe__image');
        const zoomButton = slide.querySelector('.js-photoswipe__zoom');
        if (!image || !zoomButton) return;
        image.tabIndex = 0;
        image.setAttribute('role', 'button');
        image.setAttribute('aria-label', `${image.getAttribute('alt') || 'Φωτογραφία προϊόντος'} — άνοιγμα φωτογραφίας`);
        image.addEventListener('click', event => {
          if (dragged) return;
          event.preventDefault();
          zoomButton.click();
        });
        image.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          zoomButton.click();
        });
      });
      const update = () => {
        const index = Math.max(0, Math.min(dots.length - 1, Math.round(scroller.scrollLeft / scroller.clientWidth)));
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      };
      scroller.addEventListener('scroll', update, { passive: true });
      dots.forEach(dot => dot.addEventListener('click', () => scroller.scrollTo({ left: Number(dot.dataset.galleryDot) * scroller.clientWidth, behavior: 'smooth' })));
      update();
    });
  };
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ONYRA: display the media assigned in Shopify to the selected variant. */
(() => {
  const mobile = window.matchMedia('(max-width: 768px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setVariantImage(gallery, variantId, userSelected) {
    const grid = gallery?.querySelector('[data-onyra-gallery-grid]');
    const mapNode = gallery?.querySelector('[data-onyra-variant-media-map]');
    if (!grid || !mapNode || !variantId) return;

    let mediaByVariant;
    try {
      mediaByVariant = JSON.parse(mapNode.textContent);
    } catch (error) {
      console.warn('ONYRA: variant media mapping could not be read.', error);
      return;
    }

    // No media attached to this variant: leave the existing gallery alone.
    const mediaId = mediaByVariant[String(variantId)];
    if (!mediaId) return;

    const slides = Array.from(grid.querySelectorAll('.product-main-slide[data-media-id]'));
    const selected = slides.find(slide => slide.dataset.mediaId === String(mediaId));
    if (!selected) return;

    slides.forEach(slide => {
      slide.classList.toggle('onyra-variant-featured', slide === selected);
    });

    if (mobile.matches) {
      const offset = selected.getBoundingClientRect().left
        - grid.getBoundingClientRect().left + grid.scrollLeft;
      grid.scrollTo({
        left: offset,
        behavior: userSelected && !reduceMotion.matches ? 'smooth' : 'instant'
      });

      // On mobile the product photos are above the picker.
      // Make the selected photograph visible when a customer chooses a finish.
      if (userSelected) {
        const mainPhotos = gallery.querySelector('.product__main-photos') || gallery;
        mainPhotos.scrollIntoView({
          behavior: reduceMotion.matches ? 'instant' : 'smooth',
          block: 'start'
        });
      }
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-onyra-gallery]').forEach(gallery => {
      const picker = gallery.closest('.product-section')?.querySelector('kit-variant-picker');
      if (picker?.dataset.variantId) {
        setVariantImage(gallery, picker.dataset.variantId, false);
      }
    });
  }

  document.addEventListener('kit:variant-picker:after-change', event => {
    const picker = event.target;
    if (!(picker instanceof Element) || !picker.matches('kit-variant-picker')) return;
    const gallery = picker.closest('.product-section')?.querySelector('[data-onyra-gallery]');
    const variantId = event.detail?.variant?.id || picker.dataset.variantId;
    setVariantImage(gallery, variantId, true);
  });

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
